import { render, staticRenderFns } from "./pageSideTeacherManagerDefault.vue?vue&type=template&id=d284380c&scoped=true&"
import script from "./pageSideTeacherManagerDefault.vue?vue&type=script&lang=js&"
export * from "./pageSideTeacherManagerDefault.vue?vue&type=script&lang=js&"
import style0 from "./pageSideTeacherManagerDefault.vue?vue&type=style&index=0&id=d284380c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d284380c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
